// Reimplementation of Primer's _InputValidation component
// (used by FormControl.Validation https://primer.style/react/FormControl#with-validation)
// to enable validation messaging for DropdownMenus, which is
// not natively supported (https://primer.style/react/FormControl#formcontrol)

import {AlertFillIcon, CheckCircleFillIcon, type IconProps} from '@primer/octicons-react'
import {type SxProp, Text} from '@primer/react'
import type {ComponentType, PropsWithChildren} from 'react'

import styles from './validation.module.css'

type Props = {
  validationStatus?: 'success' | 'warning' | 'error'
} & SxProp

const validationIconMap: Record<
  NonNullable<Props['validationStatus']>,
  ComponentType<React.PropsWithChildren<IconProps>>
> = {
  success: CheckCircleFillIcon,
  error: AlertFillIcon,
  warning: AlertFillIcon,
}

const validationColorMap: Record<NonNullable<Props['validationStatus']>, string> = {
  success: 'success.fg',
  error: 'danger.fg',
  warning: 'attention.fg',
}

export const Validation: React.FC<PropsWithChildren<Props>> = ({children, validationStatus, sx}) => {
  const IconComponent = validationStatus ? validationIconMap[validationStatus] : undefined
  const fgColor = validationStatus ? validationColorMap[validationStatus] : undefined

  return (
    <Text
      sx={{
        color: fgColor,
        ...sx,
      }}
      className={styles.Text}
    >
      {IconComponent && (
        <span className={styles.Box}>
          <IconComponent size={12} fill="currentColor" />
        </span>
      )}
      <span>{children}</span>
    </Text>
  )
}

try{ Validation.displayName ||= 'Validation' } catch {}